// extracted by mini-css-extract-plugin
export default {"mainContainer":"FOab2J","animationContainer":"nGIbm6","animation":"ibnB1I","stepsContainer":"BW0wkS"};